// Apps data from patronusstudio.com
// Updated with actual app data from the patronusstudio.com website

export const appsData = [
  {
    name: "FUTPEDIA - Helper & Database",
    description: "FUTPEDIA: The Most Comprehensive Companion for Football Games! Gain quick access to football games, easily view the ratings of each team through a simple and convenient interface.",
    date: "February 2024",
    color: "#4ecdc4",
    image: "/futpedia.jpg",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.patronusstudio.fifapedia",
    downloads: "80+",
    rating: "4.9"
  },
  {
    name: "Spin The Bottle 2",
    description: "Spin the Bottle 2 It's Your Turn! - Fun and Unforgettable Memories with Your Friends! A Fun and Legendary Game!",
    date: "February 2023",
    color: "#95e1d3",
    image: "/spin the bottle 2.jpg",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.patronusstudio.sisecevirmece2",
    downloads: "8K+",
    rating: "4.2"
  },
  {
    name: "Weather Forecast",
    description: "Provide you with real-time weather and local forecast reports.",
    date: "July 2020",
    color: "#87ceeb",
    image: "/weather.png",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.patronusstudio.weatherapp",
    downloads: "1K+",
    rating: "4.4"
  },
  {
    name: "BMI Calculator",
    description: "Calculate your Body Mass Index and track your health journey with our simple and easy-to-use BMI calculator.",
    date: "June 2020",
    color: "#a8b5a0",
    image: "/bmi-calculator.png",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.patronusstudio.bmicalculator",
    downloads: "1K+",
    rating: "4.2"
  },
  {
    name: "Spin The Bottle",
    description: "Are you ready to have fun and good time with your friends with Bottle Flip game? If you're getting bored when you're with your friends, how about solving the problem by playing truth or dare?",
    date: "June 2020",
    color: "#ff6b6b",
    image: "/spin the bottle.jpg",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.patronusstudio.sisecevirmece",
    downloads: "350K+",
    rating: "4.6"
  },
  {
    name: "OxFırat",
    description: "Instantly access news, announcements, events, and today's meal menu with OxFırat.",
    date: "December 2018",
    color: "#f5f5dc",
    image: "/oxfirat.jpg",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mymoonapplab.oxfirat",
    downloads: "750+",
    rating: "4.6"
  }
];

// Get total app count
export const getTotalAppsCount = () => appsData.length;
